<template>
  <div v-if="info && info.length" style="position: relative; width: 100%; height: 100%;">
    <p style="position: absolute; width: 100%; text-align: center; padding: 0; margin: 0">Firmware Version Distribution</p>
    <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: space-around;">
      <div style="height: 90%; width: 90%; margin-top: 25px; margin-left: -25px">
        <canvas id="firmareversionbarchart"></canvas> 
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default { 
  props: {
    info: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      chart: false
    }
  },

  mounted () {
   this.buildChart()
  },

  watch: {
    info() {
      this.$nextTick(() => {
        this.buildChart()
      })
    }
  },

  computed: {
    // chart data
    chartData () {
      let chartData = []
      let remainder = 0

      for(let x = 0; x < this.info.length; x++) {
        if(x < 9) {
          chartData.push(this.info[x])
        } else {
          remainder += this.info[x].device_count
        }
      }

      chartData.push({
        fw_version: 'Others',
        device_count: remainder
      })
      
      return chartData
      /*
      return this.info.reduce((set, item) => {
        set[item.fw_version] = item.device_count
        return set
      }, {})
      */
    }
  },

  methods: {
    buildChart () {
      const labels = this.chartData.map(i => i.fw_version)
      const data = {
        labels: labels,
        datasets: [{
          axis: 'x',
          label: `Number of Devices`,
          data: this.chartData.map(i => i.device_count),
          fill: false,
          barThickness: 20,
          backgroundColor: [
            '#63b2c4',
          ],
          borderColor: [
            '#63b2c4'
          ],
          borderWidth: 1
        }]
      }
      const config = {
        height: '100%;',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
            display: false,
            title: 'value'
          },
        },
        indexAxis: 'x',
        scales: {
          x: {
            title: {
              display: true,
              align: 'center',
              text: 'Firmware Version',
              color: 'rgba(0,0,0,0.6)'
            },
            grid: {
              color: 'rgba(255,255,255,0)',
              display: true,
              lineWidth: 1,
            },
            ticks: {
              beginAtZero: false,
              fontSize: 18,
              min: 1,
              max: 100,
              color: 'rgba(0,0,0,0.9)',
              backdropColor: 'rgba(255,255,255,0)',
            },
          },
          y: {
            title: {
              display: true,
              align: 'center',
              text: 'Number of Devices',
              color: 'rgba(0,0,0,0.6)'
            },
            grid: {
              color: 'rgba(0,0,0,0.3)',
              display: true,
              lineWidth: 1,
            },
            ticks: {
              beginAtZero: false,
              fontSize: 18,
              min: 1,
              max: 100,
              color: 'rgba(0,0,0,0.6)',
              backdropColor: 'rgba(255,255,255,0)',
            },
          },
        }
      }

      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(
      document.getElementById('firmareversionbarchart'), {
        type: 'bar', 
        data: data,
        options: config
      })
    }
  }
}
</script>